import { render, staticRenderFns } from "./ShowModulePage.vue?vue&type=template&id=36c14c00"
import script from "./ShowModulePage.vue?vue&type=script&lang=js"
export * from "./ShowModulePage.vue?vue&type=script&lang=js"
import style0 from "./ShowModulePage.vue?vue&type=style&index=0&id=36c14c00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports